module.exports = "/_next/static/images/eec3cec54eda60f903f3ece40ffbc52f-time.png";